import { render } from "./kakaoLoginComponent.vue?vue&type=template&id=5594c35c"
import script from "./kakaoLoginComponent.vue?vue&type=script&lang=js"
export * from "./kakaoLoginComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hooeni/Workspace/eduwind-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__